import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import ImageError from 'assets/images/404.png';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <MDBox sx={{ textAlign: 'center', maxWidth: '400px' }}>
      <MDTypography sx={{ fontSize: '32px', fontWeight: '700', marginBottom: '1rem', lineHeight: '1.2' }}>We can’t find the page you’re looking for.</MDTypography>
      <MDTypography sx={{ fontWeight: '500', marginBottom: '2rem' }}>Error 404</MDTypography>
      <MDBox sx={{ marginBottom: '1rem' }}>
        <img src={ImageError} alt='' />
      </MDBox>
      <Link to='/'>
        <MDButton color='info'>Go to home</MDButton>
      </Link>
    </MDBox>
  );
}

export default NotFound;
